import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  softwareTiles = [
    {
      title: 'Business Customisation',
      text: 'No more adjusting your business to standard softwares, Create a Software that suits your Business Process.'
    },
    {
      title: 'One Time Development, life Time Access',
      text: 'No Yearly Subscriptions or extra charges to use your software, just pay one time development and setup cost.'
    },
    {
      title: 'Flexible Payment Options',
      text: 'Pay us in monthly installments, or as per requirements are completed or as per Hours of work or Just a simple total lump sum amount.'
    },
    {
      title: 'Cloud / Third Party Integration',
      text: 'Third party API / software for payments, data authentication etc integration as per you need to create a single seamless software journey. Deploy the software on any cloud service (AWS, Google, Azure etc) as per your convenience.'
    },
    {
      title: 'Agile Approach',
      text: 'Divide the software to multiple standalone modules (Functions) which you can start using as early as 8 days from design finalisation.'
    },
    {
      title: 'UI / UX Guidance',
      text: 'To provide a business ready software we can assist you to make your software user friendly, to make it easy for you to actually create a change with technology.'
    },
  ]

  analyticsTiles = [
    {
      title: 'Business Analysis',
      text: 'Analytics Based on your business data to find out what needs to be done next with facts driven from previous data.'
    },
    {
      title: 'Report Generation',
      text: 'Configurable platform to generate recurring / one time pdf/excel reports as per requirement.'
    },
    {
      title: 'Raw Data Analysis',
      text: 'Cleaning, modifying and analysing technical data to make it readable and insightful.'
    },
    {
      title: 'Configurable Platform',
      text: 'Configurable platform for easily modifiable and adaptable report generation.'
    },
    {
      title: 'Analytics System Development',
      text: 'UI based Report Generation or real time analysis platform linked with your database.'
    },
    {
      title: 'Email, Excel, other platform Integration',
      text: 'Send the analytics over email, database etc in pdf, excel formats using our softwares'
    },
  ]

  consultancyTiles = [
    {
      title: 'Choosing Between Multiple Options',
      text: 'We will analyse multiple options in market that provide required function and help you choose the best as per your need, business etc.'
    },
    {
      title: 'Expert Analysis',
      text: 'Consultation about how you can transfer all your physical acivities and processes into a digital platform'
    },
    {
      title: 'Software Design and Structure',
      text: 'Designing and converting your complex requirements into an easy to use processes.'
    },
    {
      title: 'Development Process Management',
      text: 'Manage your development style to match your requirements, configurability and adaptability.'
    },
    {
      title: 'Productivity Optimisation',
      text: 'Apply various methods to optimise software delivery and ensure proper maintenance,'
    },
    {
      title: 'Maintenance and Refinement',
      text: 'Maintain and modify already developed software as per your requirement.'
    },
  ]

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/itheunrealist/techpixels/src/app/home/home.component.ts